import IconFont from "@/components/icon";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { DatePicker, Popover } from "antd";
const { RangePicker } = DatePicker;
import zhCN from "antd/es/date-picker/locale/zh_CN";
import "./index.less";
import { handleUserSelector } from "./operation";
import ChatState from "@/types/chat/State";
import { connect } from "dva";
import Context from "@/components/chat/context";
import { NetState } from "@/models/netStatus";
import dayjs from "dayjs";
import { usePrevious } from "@/utils/chat/index";

export interface ISearchFilterProps {
  sessionId?: string;
  placeholder?: string;
  onChange?: (search: any) => void;
  clstag?: string;
  keyword?: string;
  searchParams?: any;
}

const dateFormat = "YYYY-MM-DD";

function SearchFilter(props: ISearchFilterProps & ChatState & NetState) {
  const {
    placeholder = "搜索",
    onChange,
    selectedSession,
    currentEmployee,
    newPublicResult,
    searchParams
  } = props;
  const { groupRosters, userData } = React.useContext(Context);
  const inputRef = useRef<HTMLInputElement>(null);
  const [rangeKey, setRangeKey] = useState(new Date().getTime());
  const [dateVisable, setDateVisable] = useState(false);
  const preSessionId = usePrevious(selectedSession?.sessionId || "");

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const searchKey = (e.currentTarget.value || "").trim();
      onChange?.({
        searchKey
      });
    },
    [onChange]
  );

  // 选择日期
  const handleDateChange = useCallback(
    (val: any) => {
      if (!val) {
        onChange?.({
          startTimestamp: "",
          endTimestamp: ""
        });
      } else {
        onChange?.({
          startTimestamp: dayjs(val[0]).hour(0).minute(0).second(0).valueOf(),
          endTimestamp: dayjs(val[1]).hour(23).minute(59).second(59).valueOf()
        });
      }
    },
    [onChange]
  );

  // 清空
  const clearSearchKey = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.value = "";
      onChange?.({
        searchKey: ""
      });
    }
  }, [onChange]);

  const clearUserKey = useCallback(() => {
    onChange?.({
      selectUsers: [],
      fromUids: []
    });
  }, [onChange]);

  const dateSelectText = useMemo(() => {
    if (searchParams?.startTimestamp && searchParams?.endTimestamp) {
      return `日期：${dayjs(parseInt(searchParams?.startTimestamp, 10)).format(
        "YYYY.MM.DD"
      )} - ${dayjs(parseInt(searchParams?.endTimestamp, 10)).format("YYYY.MM.DD")}`;
    } else {
      return "日期";
    }
  }, [searchParams?.startTimestamp, searchParams?.endTimestamp]);

  const userSelectText = useMemo(() => {
    if (searchParams?.selectUsers?.length) {
      return `发送人：已选${searchParams?.selectUsers?.length}人`;
    } else {
      return <span>发送人</span>;
    }
  }, [searchParams?.selectUsers?.length]);

  const rangePickerContent = useMemo(() => {
    return (
      <RangePicker
        locale={zhCN}
        placeholder={["起始时间", "结束时间"]}
        onChange={(dates: any) => handleDateChange(dates)}
        key={rangeKey}
      />
    );
  }, [handleDateChange, rangeKey]);

  // 清空
  useEffect(() => {
    if (preSessionId && selectedSession?.sessionId !== preSessionId) {
      if (inputRef.current) {
        inputRef.current.value = "";
      }
      setRangeKey(new Date().getTime());
    }
  }, [preSessionId, selectedSession?.sessionId]);

  return (
    <div className="search-reacord-filter-container">
      <div className="search-reacord-filter-container-input">
        <IconFont type="iconjs_ic_search" className="search" />
        <input
          type="search"
          defaultValue={searchParams?.searchKey}
          placeholder={placeholder}
          ref={inputRef}
          onChange={handleInputChange}
        />
        {searchParams?.searchKey && (
          <IconFont type="iconlog_del" className="clear" onClick={clearSearchKey} />
        )}
      </div>
      <div className="filter-button">
        {selectedSession?.isGroup ? (
          <div className="item-wrap">
            <div
              className="text"
              onClick={() =>
                handleUserSelector({
                  selectedSession,
                  currentEmployee,
                  newPublicResult,
                  globalContext: {
                    groupRosters,
                    userData
                  },
                  onSelected: (res) => {
                    onChange?.({
                      selectUsers: res,
                      fromUids: res.map((r: any) => r.id)
                    });
                  },
                  defaultSelected: searchParams?.selectUsers
                })
              }
            >
              {userSelectText}
            </div>
            {searchParams?.selectUsers?.length ? (
              <IconFont type="iconlog_del" className="clear" onClick={clearUserKey} />
            ) : null}
          </div>
        ) : null}
        <div className="item" onClick={() => setDateVisable(true)}>
          <Popover
            trigger="click"
            placement="bottom"
            content={rangePickerContent}
            visible={dateVisable}
            onVisibleChange={(val) => setDateVisable(val)}
          >
            <span>{dateSelectText}</span>
          </Popover>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ chat, netStatus }: any) {
  const {
    selectedSession,
    currentEmployee,
    sessionMembers,
    allSessionList,
    messages
  } = chat as ChatState;
  const { newPublicResult, newPrivateResult } = netStatus;
  return {
    selectedSession,
    currentEmployee,
    sessionMembers,
    allSessionList,
    messages,
    newPublicResult,
    newPrivateResult
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilter);
